import { $ } from './_utility';

/*------------------------------------------------------------------

  Button.

-------------------------------------------------------------------*/
function initButton() {
  $('.wp-block-button:not(.is-style-link) .wp-block-button__link, .docspress-btn').each(
    function () {
      const $button = $(this);

      $button.html(`<span>${$button.text()}</span>`);
    }
  );
}

export { initButton };
